import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { InstitutionNameInput } from '../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/components/InstitutionNameInput/InstitutionNameInput';
import { InsuranceType } from '../../api/useInsuranceQuery';
import { FormProps } from '../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InsuranceData } from '../../useInsurance';
import { AccountDescription } from '../components/AccountDescription/AccountDescription';
import { AccountOwnerSelect } from '../components/AccountOwnerSelect/AccountOwnerSelect';
import { TabsContent } from '../components/TabsContent/TabsContent';
import { PropertyAndCasualtyDetails } from '../components/PropertyAndCasualtyDetails/PropertyAndCasualtyDetails';
import { ManagementStyles } from '../components/ManagementStyles/ManagementStyles';
import { AssetBucketing } from '../components/AssetBucketing/AssetBucketing';

interface TabProps {
  data: InsuranceData;
}

export const Summary = ({ data }: TabProps) => {
  return (
    <Box display="flex" flexDirection="column" mt="16" css="gap: 16px">
      <AccountDescription label="Description" />

      <InstitutionNameInput isInsurance />

      <AccountOwnerSelect data={data} insuranceType={InsuranceType.PropertyAndCasualty} />

      <PropertyAndCasualtyDetails data={data} />

      <ManagementStyles data={data} />

      <AssetBucketing data={data} />
    </Box>
  );
};

const tabs = [
  {
    name: 'Summary',
    Component: Summary,
  },
];

export const PropertyAndCasualtyForm = (props: FormProps) => {
  return <TabsContent tabs={tabs} {...props} />;
};
